import { SEARCH_BACKEND } from './searchConfig.js';
export { isLocaleLaunchExcludedPoi } from './locales.js';
import { resolveResourceOrigin } from './localResourceConfig.js';
import {
  AI_LOCALES,
  ALLOW_ENGLISH_ALGOLIA_FALLBACK,
  CONTENT_OVERLAY_LOCALES,
  DEFAULT_LOCALE,
  DESTINATION_CATEGORY_INDEXING_LOCALES,
  DESTINATION_PAGE_INDEXING_LOCALES,
  ENABLE_NEW_LOCALES_PUBLIC,
  GLOBAL_PAGE_INDEXING_LOCALES,
  LEGAL_PAGE_INDEXING_LOCALES,
  LOCALES,
  LOCALE_METADATA,
  MAGAZINE_LOCALES,
  PUBLIC_LOCALES,
  PUBLIC_ROLLOUT_LOCALES,
  POI_TOURS_SECTION_INDEXING_LOCALES,
  ROLLOUT_LOCALES,
  SEO_TOUR_LOCALIZATION_LOCALES,
  SUPPORTED_LOCALES,
  TOUR_ENGLISH_FALLBACK_LOCALES,
  getAllAttractionsSlug,
  getBcp47Locale,
  getDestinationIndex,
  getLocaleMetadata,
  isPublicLocale,
  isSupportedLocale,
  supportsTourEnglishFallback,
} from './locales.js';
import { GROUP_REVIEWS_EXPERIMENT_MODE, GROUP_REVIEWS_EXPERIMENT_MODES } from './experiments.js';

export {
  AI_LOCALES,
  ALLOW_ENGLISH_ALGOLIA_FALLBACK,
  CONTENT_OVERLAY_LOCALES,
  DEFAULT_LOCALE,
  DESTINATION_CATEGORY_INDEXING_LOCALES,
  DESTINATION_PAGE_INDEXING_LOCALES,
  ENABLE_NEW_LOCALES_PUBLIC,
  GLOBAL_PAGE_INDEXING_LOCALES,
  LEGAL_PAGE_INDEXING_LOCALES,
  LOCALES,
  LOCALE_METADATA,
  MAGAZINE_LOCALES,
  PUBLIC_LOCALES,
  PUBLIC_ROLLOUT_LOCALES,
  POI_TOURS_SECTION_INDEXING_LOCALES,
  ROLLOUT_LOCALES,
  SEO_TOUR_LOCALIZATION_LOCALES,
  SUPPORTED_LOCALES,
  TOUR_ENGLISH_FALLBACK_LOCALES,
  getAllAttractionsSlug,
  getBcp47Locale,
  getDestinationIndex,
  getLocaleMetadata,
  isPublicLocale,
  isSupportedLocale,
  supportsTourEnglishFallback,
  GROUP_REVIEWS_EXPERIMENT_MODE,
  GROUP_REVIEWS_EXPERIMENT_MODES,
};

export const API_KEY = 'eafe6301a53d858f5646eff9e689117e';
export const APP_ID = '87UP2KU3PD';
export const RES_URL = resolveResourceOrigin();
// TODO(legacy-tickets): Replace this manually maintained shared S3 artifact with an owned,
// generated configuration contract and migrate both the web and iOS consumers.
export const TICKETS_URL = SEARCH_BACKEND !== 'typesense' && process.env.IS_STAGE
  ? `${RES_URL}/tickets_staging.json`
  : `${RES_URL}/tickets.json`;

export const REVIEWS_SERVICE_URL = 'https://reviews.ticketlens.com';
export const CHATBOT_ENDPOINT =
  process.env.IS_STAGE || process.env.IS_STAGE_2 || process.env.NODE_ENV !== 'production'
    ? 'https://chat-test.ticketlens.com/v2/chat'
    : 'https://chat.ticketlens.com/v2/chat';

// This remains fail-closed until the privacy/legal and dual-run rollout gates are complete.
export const FIRST_PARTY_ANALYTICS_ENABLED =
  String(process.env.FIRST_PARTY_ANALYTICS_ENABLED).toLowerCase() === 'true';
export const FIRST_PARTY_ANALYTICS_ENDPOINT =
  process.env.FIRST_PARTY_ANALYTICS_ENDPOINT || 'https://events.ticketlens.com/v1/batch';
export const FIRST_PARTY_ANALYTICS_RELEASE = process.env.FIRST_PARTY_ANALYTICS_RELEASE || 'unknown';

export const PARTNER_URLS_SERVICE =
  process.env.IS_STAGE || process.env.NODE_ENV !== 'production'
    ? 'https://partnerurlstest.ticketlens.com/tours'
    : 'https://partnerurls.ticketlens.com/tours';

export const DOMAIN =
  process.env.IS_STAGE || process.env.NODE_ENV !== 'production'
    ? 'https://test.ticketlens.com'
    : process.env.IS_STAGE_2
    ? 'https://stage2.ticketlens.com'
    : 'https://www.ticketlens.com';

export const BITMAP_URL = 'https://bitmap.ticketlens.com';
export const MYSQL_HOST = process.env.IS_STAGE
  ? 'hubtestdb.ticketlens.com'
  : 'tldb-cluster.cluster-ro-cvutyrutmggo.eu-west-1.rds.amazonaws.com';
export const MYSQL_PORT = 3306;

export const INDICES = {
  TOURS: 'tours',
  DESTINATIONS: 'destinations',
  ...SUPPORTED_LOCALES.reduce((indices, locale) => {
    indices[`DESTINATIONS_${locale.toUpperCase()}`] = getDestinationIndex(locale);
    return indices;
  }, {}),
  POIS: 'pois',
  POIS_SCORE: 'pois_score',
};
